import { createFileRoute } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import AuthLayout from "@/app/auth/layout";
import Page from "@/app/employee-uploads/[uploadId]/failed-rows/page";

export const Route = createFileRoute("/employee-uploads/$uploadId/failed-rows")(
  {
    beforeLoad: ({ location }) =>
      applyAuthGuard(
        location.pathname,
        new URLSearchParams(location.searchStr),
      ),
    component: () => (
      <AuthLayout>
        <Page />
      </AuthLayout>
    ),
  },
);
